import { Button, Drawer, Input, List } from "antd";
import utils from "utils";
import icons from "Common/Icons";
import dayjs from "dayjs";
import { Form, Select, Space, DatePicker } from "antd";
// import { Col, DatePicker, Form, Input, Row, Select, Space } from "antd";
import moment from "moment";
import { useEffect, useState } from "react";
import api from "utils/api";
// import { EditOutlined } from "@ant-design/icons";
import { message as antdMessage } from "antd";
import Loader from "Components/Loader";
import { CONSTANTS } from "utils/constant";
// const { Option } = Select;

const propsName = "doctor_holiday";
//props.name
const propsFrom = "start_day";
const propsTo = "end_day";

const MyHolidays = ({ isHolidayUpdtd, setHolidayUpdtd, doctorId }) => {
  // const [editHoliday, setEditHoliday] = useState(false);

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);

  const [saving, setSaving] = useState(false);

  const [holidaysList, setHolidaysList] = useState([]);

  const [disable, setDisable] = useState(false);

  const [errorMsg, setErroMsg] = useState(null);

  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen(true);
    getListHolidays();
  };

  const onClose = () => {
    setOpen(false);
    form.setFieldsValue({doctor_holiday:[]});
    setErroMsg(null);
    // setDisable(false);
    // setErroMsg(null);
    // setEditHoliday(false);
  };

  // const handleEdit = () => {
  //   setEditHoliday(true);
  // };

  const handleSubmit = (values) => {
    setSaving(true);
    let data = values[propsName];
    if (!addAvailabilityList(data)) {
      data = data.map((m) => {
        return {
          [propsFrom]: `${utils.FormatDate(
            utils.TimezoneOffsetConversion(),
            "DATE_12"
          )} ${utils.FormatDate(m[propsFrom], "TIME_1")}`,
          [propsTo]: `${utils.FormatDate(
            utils.TimezoneOffsetConversion(),
            "DATE_12"
          )} ${utils.FormatDate(m[propsFrom], "TIME_1")}`,
        };
      });
    }
    data = data.map((m) => {
      return {
        [propsFrom]: `${utils.FormatDate(m[propsFrom], "DATE_12")} 00:00:00`,
        [propsTo]: `${utils.FormatDate(m[propsTo], "DATE_12")} 00:00:00`,
      };
    });

    // typeof props.handleFunction == "function" &&
    //   props.handleFunction(propsName, { [propsName]: data });

    api
      .addEdit_holidays_list({
        ...(doctorId && { doctor_id: doctorId }),
        [propsName]: data,
      })
      .then((response) => {
        let { status, message } = response.data || {};
        utils.Modal(false);
        if (message == "please give valid inputs")
          antdMessage.warning(utils.ConvertToPascalCase(message), ErrorDuration);
        else antdMessage.success(utils.ConvertToPascalCase(message), ErrorDuration);
        setHolidayUpdtd(!isHolidayUpdtd);
        getListHolidays();
        setSaving(false);
      })
      .catch((error) => {
        setSaving(false);
      });
    // }
  };

  const addAvailabilityList = (data, add) => {
    let tempKeys = { [propsFrom]: null, [propsTo]: null };
    let errorMsgFlag = false;
    let duplicateFlag = true;
    let errorMsg = null,
      list = data;
    let obj = Object.assign(
      tempKeys,
      (list && list.length > 0 && list[list.length - 1]) || {}
    );
    errorMsgFlag = Object.keys(obj).every((m) => (obj[m] ? true : false));
    let tempFlag = (list || []).every((m) => {
      if (m !== undefined) {
        if (
          dayjs(m[propsTo]).isSame(m[propsFrom]) ||
          dayjs(m[propsTo]).isAfter(m[propsFrom])
        )
          return true;
      } else errorMsgFlag = false;
    });

    if (list?.length > 1) {
      // if (propsName == "doctor_holiday" && list?.length > 1) {
      let entry = list[list?.length - 1];
      let array1 = [];
      list.forEach((value) => {
        let end =
          value?.end_day?.date().toString() +
          value?.end_day?.month().toString() +
          value?.end_day?.year().toString();
        let start =
          value?.start_day?.date().toString() +
          value?.start_day?.month().toString() +
          value?.start_day?.year().toString();
        if (start) {
          array1.push(start);
        }
        if (start !== end && end) {
          array1.push(end);
        }
      });
      if (new Set(array1).size !== array1.length) {
        duplicateFlag = false;
      }
    }

    if (list == undefined || list?.length == 0) add && add();
    if (!errorMsgFlag) errorMsg = "Please fill all the fields opened!";
    else {
      if (tempFlag && duplicateFlag) {
        add && add();
        // applyBtn.current.disabled = false;
        setDisable(false);
      } else {
        propsName == "doctor_availability"
          ? (errorMsg = "Invalid time selection")
          : (errorMsg = "Invalid date selection");
        // applyBtn.current.disabled = true;
        setDisable(true);
      }
    }
    if (!duplicateFlag) {
      // applyBtn.current.disabled = true;
      setDisable(true);
      errorMsg = "Duplicates are not allowed";
    }
    if (list?.length == 0 && add == undefined) {
      //if (list.length == 0) {
      errorMsg = null;
      // applyBtn.current.disabled = false;
      // setDisable(false);
     if(holidaysList.length==0)
      setDisable(true)
    }
    setErroMsg(errorMsg);
    return true;
  };

  const generateDropDown = (config, key) => {
    let { placeholder = null, data = [] } = config;
    return (
      <DatePicker
        size="small"
        format="DD/MM/YYYY"
        inputReadOnly={true}
        showToday={false}
        onChange={(val) => {
          addAvailabilityList(form && form.getFieldValue(propsName));
        }}
        // disabledDate={(current) => {
        //   let values = form.getFieldValue(propsName);
        //   if (placeholder == "From") return current < dayjs().startOf("day");
        //   else {
        //     return (
        //       (Array.isArray(values) &&
        //         values.length &&
        //         typeof values[key] == "object" &&
        //         values[key][propsFrom] &&
        //         current.startOf("day") <
        //           values[key][propsFrom].startOf("day")) ||
        //       current < dayjs().startOf("day")
        //     );
        //   }
        // }}
        placeholder={placeholder == "From" ? "Start Date" : "End Date"}
      />
    );
  };

  const getListHolidays = () => {
    // this.setState({ isLoading: true });
    setLoading(true);
    api
      .holidays_list(doctorId)
      .then((response) => {
        let { status, message, data } = response?.data;
        setHolidaysList(data.results);
        if (status == 200 && data?.results.length > 0) {
          let arr1 = data?.results.map((obj) => {
            return { ...obj, start_day: new Date(obj.start_day) };
          });
          let sortedAsc = arr1.sort(
            (objA, objB) => Number(objA.start_day) - Number(objB.start_day)
          );
          let finalHolidayData = (sortedAsc || []).map((obj) => ({
            ...obj,
            left_value: `From: ${utils.FormatDate(obj.start_day, "DATE_1")}`,
            right_value: `To: ${utils.FormatDate(obj.end_day, "DATE_1")}`,
          }));

          let from = "start_day";
          let to = "end_day";

          finalHolidayData.forEach((obj) => {
            obj[from] = dayjs(obj[from]);
            obj[to] = dayjs(obj[to]);
          });

          let tmp = { doctor_holiday: finalHolidayData };
          // this.setState({ holidays: finalHolidayData, isLoading: false });
          // setHolidaysList(finalHolidayData);

          form.setFieldsValue(tmp);

          setLoading(false);
        } else {
          setDisable(true);
          setLoading(false);
          // utils.Toast({ type: "error", message });
        }
      })
      .catch((error) => {
        // this.setState({ isLoading: false });
        antdMessage.error("Something went wrong", ErrorDuration);
        setLoading(false);
      });
  };

  return (
    <div>
      <div onClick={showDrawer} className="button-arrow">
      {CONSTANTS.HOLIDAYS}
        <img src={icons.right_arrow_dashboard} />
      </div>
      <Drawer
        destroyOnClose={true}
        title={
          <div style={{ fontWeight: "bold", fontSize: "18px" }}>{CONSTANTS.HOLIDAYS}</div>
        }
        width={500}
        onClose={onClose}
        closable={false}
        open={open}
        extra={
          <Button className="close-btn" onClick={onClose}>
            Close
          </Button>
        }
      >
        <div className="my-availability-popup">
          <div className="my-availability-popup-container">
            {loading ? (
              <Loader />
            ) : (
              <div className="popup-content">
                <div className="popup-sub-title">
                  Enter your planned non-working days
                </div>
                <div className="popup-dynamic-list">
                  <Form form={form} onFinish={handleSubmit} autoComplete="off">
                    <Form.List name="doctor_holiday">
                      {(fields, { add, remove }) => {
                        return (
                          <>
                            {fields.map(({ key, name, ...restField }) => (
                              <div key={key} className="list-item">
                                <div className="list-item-content">
                                  <Form.Item
                                    {...restField}
                                    required={false}
                                    name={[name, propsFrom]}
                                    label="From"
                                    rules={[{ required: true, message: "" }]}
                                  >
                                    {generateDropDown(
                                      { placeholder: "From" },
                                      key
                                    )}
                                  </Form.Item>
                                  <Form.Item
                                    {...restField}
                                    required={false}
                                    name={[name, propsTo]}
                                    label="To"
                                    rules={[{ required: true, message: "" }]}
                                  >
                                    {generateDropDown(
                                      { placeholder: "To" },
                                      key
                                    )}
                                  </Form.Item>
                                </div>
                                <div
                                  onClick={() => {
                                    remove(name);
                                    addAvailabilityList(
                                      form && form.getFieldValue(propsName)
                                    );
                                  }}
                                  className="remove-icon"
                                >
                                  <img
                                    style={{ width: "15px" }}
                                    src={icons.delete}
                                  />
                                </div>
                              </div>
                            ))}
                            {(errorMsg && (
                              <div className="error-message">{errorMsg}</div>
                            )) ||
                              null}
                            <Button
                              className="add-button"
                              onClick={() =>
                                addAvailabilityList(
                                  form && form.getFieldValue("doctor_holiday"),
                                  add
                                )
                              }
                              // onClick={() => addAvailabilityList(form, add)}
                            >
                              Add Leave Days
                            </Button>
                          </>
                        );
                      }}
                    </Form.List>
                    <div
                      className={
                        disable ? "submit-button-disable" : "submit-button"
                      }
                    >
                      <Button
                        // ref={applyBtn}
                        htmlType="submit"
                        disabled={disable}
                        loading={saving}
                        // onClick={() => {
                        //   form && form.submit();
                        // }}
                      >
                        Apply
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            )}
          </div>
        </div>
      </Drawer>
    </div>
  );
};
export default MyHolidays;